export default {
    Bike: 'Bike',
    Ped: 'Ped',
    Swim: 'Swim',
    Grinding: 'Grinding',
    Wheelchair: 'Wheelchair',
    NonRunning: 'NonRunning',
    Unknown: 'Unknown'
};
